import { Component, Input, OnInit } from '@angular/core';
import { ChartDataSets, ChartType } from 'chart.js';
import { Color, Label } from 'ng2-charts';
import { DataCharts } from 'src/app/model/installation/charts.model';
import { InstallationsService } from 'src/app/services/http/installations/installations.service';

@Component({
  selector: 'app-installation-monthly-evolution',
  templateUrl: './installation-monthly-evolution.component.html',
  styleUrls: ['./installation-monthly-evolution.component.scss']
})
export class InstallationMonthlyEvolutionComponent implements OnInit {

  @Input() installation : any;

  lineChartData: ChartDataSets[] = [];
  lineChartDataPizzas: ChartDataSets[] = [];
  lineChartDataCa: ChartDataSets[] = [];

  lineChartLabels: Label[] = [];
  chartDatasPizzas: any[]=[];
  chartDatasCa: any[]=[];

  lineChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          }
        }
      ]
    }
  };



  lineChartColors: Color[] = [
    {
      borderColor: '#8888e8',
      backgroundColor: 'rgba(255,255,255,0.28)',
      pointBorderColor: '#5555e8',
      pointBackgroundColor: '#5555e8'
    },
    {
      borderColor: '#84e087',
      backgroundColor: 'rgba(255,255,255,0.28)',
      pointBorderColor: '#579459',
      pointBackgroundColor: '#579459'
    }
  ];

  lineChartLegend = true;
  lineChartPlugins = [];
  lineChartType: ChartType = 'line';

  constructor(private service: InstallationsService) { }

  public charts !: DataCharts;


  ngOnInit(): void {


    if (this.installation) {

      this.service.getChartsData((this.installation.id_backup).toString()).subscribe((charts) => {
        this.charts = charts;

for(var i = 0;i<charts.data_chart1.length;i++){
  this.lineChartLabels[i]=charts.data_chart1[i].mois;
  this.chartDatasPizzas[i] = charts.data_chart1[i].pizzas;
  this.chartDatasCa[i] = charts.data_chart1[i].ca;
}
 

        this.lineChartDataPizzas = [
          {
            data: this.chartDatasPizzas, label: 'Pizzas vendues'
          }
        ];
        this.lineChartDataCa = [
          {
            data: this.chartDatasCa, label: 'Chiffre d\' affaires (€) '
          }
        ];

        this.lineChartData = [
          {
            data: this.chartDatasPizzas, label: 'Pizzas vendues'
          },
          {
            data: this.chartDatasCa, label: 'Chiffre d\' affaires'
          }
        ]

        // console.log(charts);
        // console.log( parseFloat(charts.data_chart3[0].ventes_count));

      })
    }

  }

}
